import apiClient from '@/utils/api';

const API = process.env.REACT_APP_BACKEND_URL;

// Normalise any file URL (absolute or /api/...) to the API-relative path used by apiClient
export const toApiPath = (url) => {
  if (!url) return '';
  let p = url.startsWith('http') ? url.replace(API, '') : url;
  return p.replace(/^\/api/, '');
};

// Open a protected document in the in-app viewer (navigates within the app so back button works)
export const openDocument = (url, name = 'documento.pdf', navigate) => {
  const viewer = `/documento?src=${encodeURIComponent(toApiPath(url))}&name=${encodeURIComponent(name)}`;
  if (navigate) { navigate(viewer); return; }
  // Use _self so the browser back button returns to the previous page
  window.location.assign(viewer);
};

const errorMessage = async (e, fallback) => {
  try {
    if (e?.response?.data instanceof Blob) {
      const parsed = JSON.parse(await e.response.data.text());
      if (parsed?.detail) return typeof parsed.detail === 'string' ? parsed.detail : fallback;
    }
    if (typeof e?.response?.data?.detail === 'string') return e.response.data.detail;
  } catch { /* ignore */ }
  if (e?.code === 'ECONNABORTED') return 'O servidor demorou demasiado a gerar o ficheiro. Tente novamente.';
  return fallback;
};

// Fetch a protected file as a Blob (with Bearer token). Throws with a user-facing message.
export const fetchDocumentBlob = async (url, { timeout = 200000 } = {}) => {
  try {
    const res = await apiClient.get(toApiPath(url), { responseType: 'blob', timeout });
    const disposition = res.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^";]+)"?/i);
    return { blob: res.data, filename: match ? match[1] : null, type: res.headers['content-type'] || res.data.type };
  } catch (e) {
    throw new Error(await errorMessage(e, 'Não foi possível obter o ficheiro. Tente novamente.'));
  }
};

// Download a protected file: fetch with token, then trigger a save (a[download])
export const downloadDocument = async (url, fallbackName = 'ficheiro.pdf') => {
  const { blob, filename } = await fetchDocumentBlob(url);
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename || fallbackName;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};
